<script setup lang="ts">
import { computed } from 'vue';

import GenericModal from '~/components/shared/GenericModal.vue';

const props = defineProps<{
  loading?: boolean;
  show: boolean;
}>();

const emit = defineEmits<{
  cancel: [];
  confirm: [];
}>();

const isOpen = computed({
  get: () => props.show,
  set: (value: boolean) => {
    if (!value) emit('cancel');
  },
});
</script>

<template>
  <GenericModal
    v-model="isOpen"
    title="Ativar incentivo"
    primary-button-text="Ativar"
    secondary-button-text="Cancelar"
    :loading="loading"
    @primary-action="emit('confirm')"
    @secondary-action="emit('cancel')"
  >
    <p class="modal-summary">
      Ao ativar, este incentivo passa a ficar disponível para ser selecionado em novas campanhas.
    </p>
  </GenericModal>
</template>

<style scoped lang="scss">
.modal-summary {
  margin: 0;
  color: #374151;
  font-size: 14px;
  line-height: 1.5;
}
</style>
